import productoService from '../services/productoService';
import {
  cantidadHaciaUmStock,
  umStockDesdeDetalle,
} from './umVentaDocumento';

/**
 * Tipos de comprobante en el hilo de ventas que representan factura.
 * El POS usa a menudo "12" también para factura (además de pedido).
 */
export const TIPOS_FACTURA_HILO = new Set(['1', '2', '12']);
export const TIPO_REMITO_HILO = '9';
export const TIPO_NC_HILO = '3';

/**
 * Convierte una cantidad (típicamente de remito en UM stock) a la misma
 * base de comparación que la línea de factura (UM documental → stock).
 * Así pendiente = facturadoEnStock - remitidoEnStock.
 */
export async function cantidadLineaAUmStock(
  codigoArticulo: string,
  cantidad: number,
  umLinea: string | null | undefined,
): Promise<number> {
  const qty = Number(cantidad) || 0;
  if (!(qty > 0)) return 0;
  const codigo = String(codigoArticulo ?? '').trim();
  const um = String(umLinea ?? '').trim();
  if (!codigo || !um) return qty;

  try {
    const detalle = await productoService.getEquivalenciasUmDetalle(codigo);
    const umStock = umStockDesdeDetalle(detalle);
    if (!umStock) return qty;
    return cantidadHaciaUmStock(qty, um, umStock, detalle.equivalencias ?? []);
  } catch {
    return qty;
  }
}
